import { matchesBlogFilters } from "./blog/filters";

const browser = document.querySelector<HTMLElement>("[data-blog-browser]");
const form = browser?.querySelector<HTMLFormElement>(".blog-filters");
const topic = form?.querySelector("select");
const count = browser?.querySelector<HTMLElement>("[data-blog-count]");
const empty = browser?.querySelector<HTMLElement>(".blog-empty");

if (browser && form && topic && count && empty) {
  const collections = [...form.querySelectorAll<HTMLInputElement>("input[name='collection']")];
  const posts = [...browser.querySelectorAll<HTMLElement>("[data-blog-post]")];

  const indicator = browser.querySelector<HTMLElement>("[data-page-indicator]")!;
  const previous = browser.querySelector<HTMLButtonElement>("[data-page-prev]")!;
  const next = browser.querySelector<HTMLButtonElement>("[data-page-next]")!;
  const pageSize = Number(browser.dataset.pageSize);
  let currentPage = 1;

  const applyFilters = () => {
    const filters = {
      collection: collections.find((input) => input.checked)?.value ?? "all",
      topic: topic.value,
    };
    const matching = posts.filter((post) =>
      matchesBlogFilters(
        {
          category: post.dataset.category ?? "",
          badges: post.dataset.badges?.trim().split(/\s+/).filter(Boolean),
        },
        filters,
      ),
    );
    const visible = matching.length;
    const pageCount = Math.max(1, Math.ceil(visible / pageSize));
    currentPage = Math.min(currentPage, pageCount);
    const pagePosts = new Set(matching.slice((currentPage - 1) * pageSize, currentPage * pageSize));
    for (const post of posts) post.hidden = !pagePosts.has(post);
    indicator.textContent = `${currentPage}/${pageCount}`;
    indicator.setAttribute("aria-label", `Page ${currentPage} of ${pageCount}`);
    previous.hidden = next.hidden = pageCount === 1;
    previous.disabled = currentPage === 1;
    next.disabled = currentPage === pageCount;
    count.textContent = `${visible} ${visible === 1 ? "guide" : "guides"}`;
    empty.hidden = visible !== 0;

    const url = new URL(location.href);
    for (const [key, value] of Object.entries(filters)) {
      if (value === "all") url.searchParams.delete(key);
      else url.searchParams.set(key, value);
    }
    if (currentPage === 1) url.searchParams.delete("page");
    else url.searchParams.set("page", String(currentPage));
    history.replaceState(null, "", url);
  };

  const restoreFilters = () => {
    const params = new URLSearchParams(location.search);
    const requestedPage = Number(params.get("page"));
    currentPage = Number.isSafeInteger(requestedPage) && requestedPage > 0 ? requestedPage : 1;
    const collection = collections.find((input) => input.value === params.get("collection"));
    (collection ?? collections[0]).checked = true;
    topic.value = [...topic.options].some((option) => option.value === params.get("topic"))
      ? params.get("topic")!
      : "all";
    applyFilters();
  };

  form.addEventListener("change", () => {
    currentPage = 1;
    applyFilters();
  });
  const changePage = (offset: number) => {
    currentPage += offset;
    applyFilters();
    browser.scrollIntoView({ block: "start" });
  };
  previous.addEventListener("click", () => changePage(-1));
  next.addEventListener("click", () => changePage(1));
  form.addEventListener("submit", (event) => event.preventDefault());
  empty.querySelector<HTMLButtonElement>("button")?.addEventListener("click", () => {
    form.reset();
    currentPage = 1;
    applyFilters();
    collections[0].focus();
  });
  window.addEventListener("popstate", restoreFilters);
  restoreFilters();
  form.hidden = false;
}
